var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCandidates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44961 17.3281C7.79961 17.3281 2.84961 17.3281 2.84961 13.9531C2.84961 10.5781 7.64961 10.5781 9.44961 10.5781C11.0996 10.5781 15.9746 10.5781 15.9746 13.9531C16.0496 17.3281 11.2496 17.3281 9.44961 17.3281ZM9.44961 11.7031C5.77461 11.7031 3.97461 12.3781 3.97461 13.9531C3.97461 15.4531 5.77461 16.2031 9.44961 16.2031C13.1246 16.2031 14.8496 15.5281 14.8496 13.9531C14.9246 12.4531 13.1246 11.7031 9.44961 11.7031Z",
    fill: "#C1C5D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44961 9.45C7.04961 9.45 5.09961 7.5 5.09961 5.1C5.09961 2.7 7.04961 0.75 9.44961 0.75C11.8496 0.75 13.7996 2.7 13.7996 5.1C13.7996 7.5 11.9246 9.45 9.44961 9.45ZM9.44961 1.8C7.64961 1.8 6.22461 3.225 6.22461 5.025C6.22461 6.825 7.64961 8.25 9.44961 8.25C11.2496 8.25 12.7496 6.825 12.7496 5.025C12.7496 3.225 11.2496 1.8 9.44961 1.8Z",
    fill: "#C1C5D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidates);
export default __webpack_public_path__ + "static/media/candidates.48aba27a7026e731820cb46624d8c4f7.svg";
export { ForwardRef as ReactComponent };